// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import Ajax from '@U/ajax'
import verifyRules from '@U/verifyRules'
import validation from '@U/validation'
import filter from '@U/filter'
import verify from "vue-verify-plugin"
import '@A/scss/all.scss'
// import 'ie-placeholder'

import formRow from '@C/formRow'
import partProgress from '@C/partProgress'
import HkRadio from '@C/HkRadio'
import HkCheckbox from '@C/HkCheckbox'
import cmsele from '@C/cmsele'
import HkSelect from '@C/HkSelect'
import myConfirm from '@C/confirm'
import '@A/css/bootstrap.css'

Vue.config.productionTip = false
var eventHandle = new Vue()

Vue.use(Ajax)
Vue.use(validation)
// 表單驗證
Vue.use(verify, {
  blur: true,
	rules: verifyRules
})
filter.init(Vue)

// 組件
Vue.component('form-row', formRow)
Vue.component('part-progress', partProgress)
Vue.component('hk-radio', HkRadio)
Vue.component('hk-checkbox', HkCheckbox)
Vue.component('hk-select', HkSelect)
Vue.component('myConfirm', myConfirm)
Vue.component('cmsele', cmsele)
Vue.prototype.$formPartProgress = 0

// 頁面跳轉 val是跳轉頁面的路徑, obj是跳轉頁面時傳的參數
Vue.prototype.$toPage = function(val, obj) {
  this.$router.push({
    path: val,
    query: obj || {}
  })
  document.getElementsByTagName('html')[0].scrollTop = 0
}

Vue.prototype.setFormPartProgress = function(part) {
  if(part >= this.getFormPartProgress()){
    Vue.prototype.$formPartProgress = part;
    console.log(`Setting Form Progress ${Vue.prototype.$formPartProgress}`)
  }
  
}
Vue.prototype.getFormPartProgress = function() {
  return Vue.prototype.$formPartProgress;
}

// localStorage
Vue.prototype.setItem = (key, val) => {
  localStorage && localStorage.setItem(key, val)
}
Vue.prototype.getItem = (key) => {
  return localStorage && localStorage.getItem(key)
}
Vue.prototype.removeItem = (key) => {
  localStorage && localStorage.removeItem(key)
}
// sessionStorage
Vue.prototype.sessionSetItem = (key, val) => {
  sessionStorage && sessionStorage.setItem(key, val)
}
Vue.prototype.sessionGetItem = (key) => {
  return sessionStorage && sessionStorage.getItem(key)
}
Vue.prototype.sessionRemoveItem = (key) => {
  sessionStorage && sessionStorage.removeItem(key)
}
//base64 解密 (调用decode)
Vue.prototype._keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
Vue.prototype._utf8_decode = function (utftext) {
  var string = "", i = 0, c = 0, c1 = 0, c2 = 0, c3 = 0;
  while ( i < utftext.length ) {
      c = utftext.charCodeAt(i);
      if (c < 128) {
          string += String.fromCharCode(c);
          i++;
      } else if((c > 191) && (c < 224)) {
          c2 = utftext.charCodeAt(i+1);
          string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
          i += 2;
      } else {
          c2 = utftext.charCodeAt(i+1);
          c3 = utftext.charCodeAt(i+2);
          string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
          i += 3;
      }
  }
  return string;
}
Vue.prototype.decode = function (input) {
  var output = "", chr1, chr2, chr3, enc1, enc2, enc3, enc4, i = 0;
  input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  while (i < input.length) {
    enc1 = this._keyStr.indexOf(input.charAt(i++));
    enc2 = this._keyStr.indexOf(input.charAt(i++));
    enc3 = this._keyStr.indexOf(input.charAt(i++));
    enc4 = this._keyStr.indexOf(input.charAt(i++));
    chr1 = (enc1 << 2) | (enc2 >> 4);
    chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
    chr3 = ((enc3 & 3) << 6) | enc4;
    output = output + String.fromCharCode(chr1);
    if (enc3 != 64) {
      output = output + String.fromCharCode(chr2);
    }
    if (enc4 != 64) {
      output = output + String.fromCharCode(chr3);
    }
  }
  output = this._utf8_decode(output);
  return output;
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  data: {
    eventHandle: eventHandle,
    languageData: {},
  }
})



// WEBPACK FOOTER //
// ./src/main.js